import FetchClient, { type ApiResponse } from "./FetchClient";

export type ReferralBillingProvider = "stripe" | "apple" | "google" | "";

export interface ReferralStatus {
  inviteUrl: string;
  creditsBanked: number;
  creditsApplied: number;
  earnedThisYear: number;
  annualLimit: number;
  billingProvider: ReferralBillingProvider;
  canApply: boolean;
  automatic: boolean;
  pendingRedemptionId?: string;
  pendingRedemptionProvider?: ReferralBillingProvider;
}

export interface ReferralRedemption {
  redemptionId: string;
  provider: ReferralBillingProvider;
  status: "pending" | "scheduled" | "queued";
  offerIdentifier?: string;
  creditsBanked: number;
}

export async function getReferralStatus(): Promise<ReferralStatus> {
  const response = await FetchClient.get<ApiResponse<ReferralStatus>>("/referrals/status");
  return response.data;
}

export async function applyReferralCredit(): Promise<ReferralRedemption> {
  const response = await FetchClient.post<ApiResponse<ReferralRedemption>>("/referrals/apply", {});
  return response.data;
}

export async function cancelReferralRedemption(redemptionId: string): Promise<void> {
  await FetchClient.post<ApiResponse<{ canceled: boolean }>>("/referrals/redeem/cancel", {
    redemptionId,
  });
}
